import {useEffect} from "react";
import {Banner, Benefits, FAQ, Help, LandingBlog, PoweredBy, Process,} from "../components";
import {Helmet} from "react-helmet";
import {useLocation, useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {getAllQueryParams} from "../utils/url.js";
import {updateReferralCode, updateMarketingMetadata} from "../redux/slices/application-process.slice.js";

function Home({blogs, publicIP, curpFillType, setIsHomePage}) {

    const search = useLocation().search;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const marketing_metadata = useSelector(state => state.applicationProcess.marketingMetadata);
    const referralCode = useSelector(state => state.applicationProcess.referralCode);

    function handleReferralsRedirection() {
        if (referralCode) return;
        const marketing_metadata = getAllQueryParams(search);
        const {referrer = null} = marketing_metadata;
        if (referrer) {
            dispatch(updateReferralCode(referrer));
            navigate('/app/landing');
        }
    }

    function handleMarketingMetadata() {
        if (marketing_metadata) return;
        const dataAux = getAllQueryParams(search);
        console.log(dataAux);
        dispatch(updateMarketingMetadata(dataAux));
    }

    useEffect(() => {
        handleMarketingMetadata()
        handleReferralsRedirection();
    }, []);

    useEffect(() => {
        setIsHomePage(true);
        return () => {
            setIsHomePage(false);
        };
    }, [setIsHomePage]);

    return (
        <>
            <Helmet>
                <meta charSet="utf-8"/>
                <title>Préstamos Personales En Línea, Al Instante y Seguros | Beloz </title>
                <meta name="description"
                      content="Préstamos en línea personales, grupales, para emprendedores y más. Tu primer préstamo es sin interés. Mejora tu historial crediticio. Renovables y seguros."/>
            </Helmet>
            {/* <Header handleOpen={handleOpen} />
      <Download />
      <WUs />
      <Testimonials /> */}
            <Banner publicIP={publicIP} curpFillType={curpFillType}/>
            <Benefits/>
            <Process publicIP={publicIP} curpFillType={curpFillType}/>
            {blogs.length > 0 && <LandingBlog blogs={blogs}/>}
            <PoweredBy/>
            <FAQ/>
            <Help/>
        </>
    );
}

export default Home;
